import React from "react";
import "../styles/about.css";

import hotel from "../assets/icons/hotel.png";
import crypto from "../assets/icons/crypto.png";
import plane from "../assets/icons/plane.png";
import insurance from "../assets/icons/insurance.png";
import reward from "../assets/icons/reward.png";
import score from "../assets/icons/score.png";

const About = () => {
  const features = [
    {
      icon: hotel,
      title: "Flight & Hotel",
      title2: "Booking",
    },
    {
      icon: crypto,
      title: "Crypto",
      title2: "Payment",
    },
    {
      icon: plane,
      title: "Flight",
      title2: "Mining",
    },
    {
      icon: insurance,
      title: "Delay",
      title2: "Insurance",
    },
    {
      icon: reward,
      title: "Travel",
      title2: "Rewards",
    },
    {
      icon: score,
      title: "AI Travel",
      title2: "Score",
    },
  ];

  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="about-wrapper">

          <div className="row align-items-center">

            {/* Left Content */}
            <div className="col-lg-3">
              <div className="about-content">

                <h2 className="about-number">
                  01 ABOUT
                </h2>

                <h3 className="about-title">
                  What is SkyTerminal?
                </h3>

                <p>
                  SkyTerminal is a next-generation TravelFi
                  platform that connects real-world travel
                  with blockchain technology to create a
                  rewarding travel experience.
                </p>

              </div>
            </div>

            {/* Right Icons */}
            <div className="col-lg-9">
              <div className="features-grid">

                {features.map((item, index) => (
                  <div className="feature-card" key={index}>
                    <img
                      src={item.icon}
                      alt={item.title}
                    />

                    <h4>
                      {item.title}
                      <br />
                      {item.title2}
                    </h4>
                  </div>
                ))}

              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default About;